export default {
    BASE_URL: process.env.REACT_APP_BASE_URL || '', // URL da API
    WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL || '', // URL do Website
    WEBAPP_URL: process.env.REACT_APP_WEBAPP_URL || 'http://localhost:3000', // URL da Webapp
    STAGING_PASSWORD: process.env.REACT_APP_STAGING_PASSWORD || '', // Senha de acesso ao ambiente de staging
    IS_STAGING: Boolean(process.env.REACT_APP_IS_STAGING) || false, // Variável de ambiente que indica se o ambiente é de staging
    NODE_ENV: process.env.NODE_ENV || '', // Variável de ambiente que indica o ambiente de execução
};
